<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ ticketType }} Ticket</h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- NAME -->
        <vs-input
          label="Ticket Name"
          v-model="data_local.TicketName"
          class="mt-5 w-full"
          name="TicketName"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('TicketName')">{{
          errors.first("TicketName")
        }}</span>

        <!-- NAME -->
        <vs-input
          label="Quantity"
          v-model="data_local.quantity"
          class="mt-5 w-full"
          name="Quantity"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Quantity')">{{
          errors.first("Quantity")
        }}</span>

        <!-- Company -->
        <div class="mt-5">
          <label>Description</label>
          <vs-textarea
            class="w-full"
            name="Description"
            v-model="data_local.Description"
            data-vv-as="Notification Message"
            v-validate="'required'"
          />
        </div>
        <!-- <vs-input
          label="Description"
          v-model="data_local.Description"
          class="mt-5 w-full"
          name="Description"
        /> -->
        <span class="text-danger text-sm" v-show="errors.has('Description')">{{
          errors.first("Description")
        }}</span>

        <!-- Email -->
        <div class="mt-3 theme-select-flex-box">
          <span class="lobbtTagText">Advance settings</span>

          <vs-switch
            v-model="AdvanceSettings"
            @change="onAdvanceSettingsChange"
          >
            <span slot="On" vs-value="2" name="regAdvanceSettings">On</span>
            <span slot="Off" vs-value="1" name="regAdvanceSettings">Off</span>
          </vs-switch>
        </div>
        <br />
        <!-- Password -->
        <div v-if="AdvanceSettings" class="vx-row px-4">
          <label>Ticket Avaialability</label>
          <div class="textbox-beside-wrap ticket-availability-wrap mt-5">
            <label>Sales Start </label>
            <vs-select class="select-large">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in TicketStartOptions"
                class="w-full"
                v-onchange="OpenModal()"
              />
            </vs-select>
          </div>
          <br />
          <br />
          <div v-show="IsStartScheduled" class="vx-col md:w-1/2 w-full mt-5">
            <label style="padding-right: 10px">Select Date and Time</label>
            <flat-pickr
              :config="configdateTimePickerStart"
              name="Schedule Date"
              v-model="ScheduleStartDate"
              placeholder="Schedule Date"
              class="time-pkr"
              style="padding-right: 10px"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Start Time')"
              style="padding-right: 10px"
              >{{ errors.first("Start Time") }}</span
            >
          </div>
          <div class="textbox-beside-wrap ticket-availability-wrap mt-5">
            <label>Sales End </label>
            <vs-select class="select-large">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in TicketEndOptions"
                class="w-full"
                v-onchange="OpenModal()"
              />
            </vs-select>
          </div>
          <br />
          <br />
          <div v-show="IsEndScheduled" class="vx-col md:w-1/2 w-full mt-5">
            <label style="padding-right: 10px">Select Date and Time</label>
            <flat-pickr
              :config="configdateTimePickerStart"
              name="Schedule Date"
              v-model="ScheduleEndDate"
              placeholder="Schedule Date"
              class="time-pkr"
              style="padding-right: 10px"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Start Time')"
              style="padding-right: 10px"
              >{{ errors.first("Start Time") }}</span
            >
          </div>
        </div>
        <!-- <div class="pt-5">
          <vs-radio
            v-model="data_local.adminType"
            vs-value="EventAdmin"
            vs-name="navbar-type-sticky"
            class="mr-3"
            >Event Admin</vs-radio
          >
          <vs-radio
            v-model="data_local.adminType"
            vs-value="AnalyticsAdmin"
            vs-name="navbar-type-floating"
            >Analytics Admin2</vs-radio
          >
        </div> -->
        <div class="mt-5 free-ticket-status">
          <label>Ticket Status </label>
          <vs-radio
            v-model="Statuselected"
            vs-value="openticketstatus"
            class="mr-4 ml-4"
            vs-name="Statuselected"
            @change="onSelectButtonChange"
            >Open</vs-radio
          >
          <vs-radio
            v-model="Statuselected"
            vs-value="closeticketstatus"
            class="mr-4"
            vs-name="Statuselected"
            @change="onSelectButtonChange"
            >Close</vs-radio
          >
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    VuePerfectScrollbar,
    flatPickr,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      Statuselected: "openticketstatus",
      IsEndScheduled: false,
      ScheduleEndDate: "",
      IsStartScheduled: false,
      ScheduleStartDate: "",
      TicketStartOptions: [
        { text: "Immediately after publishing", value: "0" },
        { text: "On specific Date & Time", value: "1" },
      ],
      TicketEndOptions: [
        { text: "Immediately after publishing", value: "0" },
        { text: "On specific Date & Time", value: "1" },
      ],
      AdvanceSettings: false,
      ticketType: "Free",
      data_local: this.data,
      configdateTimePicker: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          //if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      this.data_local = this.data;
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
    isFormValid() {
      return !this.errors.any();
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    onSelectButtonChange: function (context, LobbyType) {
      debugger;
      // if (vm.sourceselected == "openticketstatus") {
      //   vm.IsAllAttendeeSelect = false;
      //   this.ISGroupSelect = false;
      //   this.IsAttendeeSelect = true;
      // } else if (vm.sourceselected == "closeticketstatus") {
      //   vm.IsAllAttendeeSelect = false;
      //   this.ISGroupSelect = true;
      //   this.IsAttendeeSelect = false;
      // }
    },
    onAdvanceSettingsChange: function (context, LobbyType) {
      //debugger

      if (this.AdvanceSettings) {
        this.AdvanceSettings = false;
      } else {
        this.AdvanceSettings = true;
      }
    },
    OpenModal() {
      console.log("OpenModal");
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.data_local.EventAdminId > 0) {
            this.$vs.loading();
            this.$store
              .dispatch("eventManagement/updateEventAdmin", {
                data: this.data_local,
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$vs.notify({
                    position: "top-center",
                    color: "success",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                if (res.status == 500) {
                  this.$vs.notify({
                    position: "top-center",
                    color: "warning",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                this.$vs.loading.close();
                //this.$router.push({ name: "eventadmins" });
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.$vs.loading();
            this.$store
              .dispatch("eventManagement/addEventAdmin", {
                data: this.data_local,
              })
              .then((res) => {
                if (res.status == 200) {
                  this.$vs.notify({
                    position: "top-center",
                    color: "success",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                if (res.status == 500) {
                  this.$vs.notify({
                    position: "top-center",
                    color: "warning",
                    title: "Event Admin",
                    text: res.message,
                  });
                }
                this.$vs.loading.close();
                //this.$router.push({ name: "eventadmins" });
              })
              .catch((err) => {
                console.log(err);
              });
          }

          this.$vs.loading.close();
          this.$emit("closeSidebar");

          //this.initValues()
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
